import { useMapContext } from '../../../_MapContext';
import { useNavigation } from '../../../_NavigationContext';
import { UIIconBtn, UIIconToggle } from '../basic';
import { UIZoomBtn, UIIconSelectLang } from '../composite';

const MapOverlayUI = ({ onUIBtnClick, minZoom, maxZoom, modalMenuOpened, hasNewStamp, infoModalOpen, stampcardOpen }) =>
{
	const { bfMapState, hasPinsState, setHasPins, autoCenterEnabled, hasTargetPin } = useMapContext();
	const { navigateToHomeDirect, closeNavigationModal } = useNavigation();

	const handleHasPinsToggle = (value) =>
	{
		setHasPins(value ? 1 : 0);
	};

	const handleHomeClick = () =>
	{
		navigateToHomeDirect();
	};

	const handleMenuClick = (btnKey, map) =>
	{
		if (modalMenuOpened) {
			// If menu is already open, close it
			closeNavigationModal();
		} else {
			// Otherwise use the default handler to open it
			onUIBtnClick(btnKey, map);
		}
	};

	const ToggleMapPinBtn = () =>
	(
		<UIIconToggle
			className={`btn-has-pin`}
			iconClass="map-pin"
			value={hasPinsState !== 0}
			onChange={handleHasPinsToggle}
		/>
	);

	return (
		<div className="overlay-ui">
			<div className="upper-ui">
				<div className="left-ui">
					<div className="ui-group">
						<UIIconBtn id="btn-map-home" className={`btn-map-home circle`} btnKey="home" iconClass="home" onClick={onUIBtnClick} />
						<UIIconBtn
							id="btn-stampcard"
							className="btn-stampcard circle"
							btnKey="stampcard"
							iconClass="stampcard"
							onClick={onUIBtnClick}
							showNotification={hasNewStamp}  
						/>
					</div>
				</div>
				<div className="right-ui">
					<div className="ui-block ui-tl">
						<div className="ui-group universal pc-only">
							<UIIconBtn
								className={`btn-handicap circle b-b ${bfMapState ? 'selected' : ''}`}
								btnKey="handicap"
								iconClass="wheelchair"
								onClick={onUIBtnClick}
							/>
							<ToggleMapPinBtn/>
							<UIIconSelectLang/>
							{/* PC-only home-sub button that only shows when any drawer modal is open */}
							{(modalMenuOpened || infoModalOpen || stampcardOpen) && (
								<UIIconBtn 
									id="btn-map-home-sub" 
									className={`btn-map-home circle pc-only`} 
									btnKey="home-sub" 
									iconClass="home" 
									onClick={handleHomeClick} 
								/>
							)}
						</div>
						<div className="ui-group menu">
							<UIIconBtn id="btn-map-menu" className={`btn-map-menu circle ${modalMenuOpened ? 'selected' : ''}`} btnKey="menu" iconClass="menu" onClick={handleMenuClick} />
							<UIIconBtn className="btn-legend circle b-w pc-only" btnKey="legends" iconClass="question" onClick={onUIBtnClick} />
						</div>
					</div>
				</div>
			</div>
			<div className="lower-ui">
				<div className="left-ui">
					<div className="ui-group sp-only">
						<UIIconBtn className="btn-legend circle b-w" btnKey="legends" iconClass="question" onClick={onUIBtnClick} />
						<UIIconBtn
							className={`btn-handicap circle b-b ${bfMapState ? 'selected' : ''}`}
							btnKey="handicap"
							iconClass="wheelchair"
							onClick={onUIBtnClick}
						/>
						<ToggleMapPinBtn/>
					</div>
				</div>
				<div className="right-ui">
					<div className="ui-group">
						<UIZoomBtn
							onClick={onUIBtnClick}
							minZoom={minZoom}
							maxZoom={maxZoom}
							className="sp-only"
						/>
						{hasTargetPin && (
							<UIIconBtn
								className={`btn-target-pin circle b-w selected`}
								btnKey="target-pin"
								iconClass="map-pin"
								onClick={onUIBtnClick}
							/>
						)}
						<UIIconBtn
							className={`btn-map-center circle b-w ${autoCenterEnabled ? 'auto-center' : ''}`}
							btnKey="map-center"
							iconClass="map-center"
							onClick={onUIBtnClick}
						/>
					</div>
				</div> 
			</div>
		</div>
	);
};

export default MapOverlayUI;